import { action } from 'typesafe-actions';
import { HttpRequest } from 'types/rest/analyticsTypes';
import {
  SELECT_WEBHOOK_DETAIL_TAB,
  SELECT_WEBHOOK_VIEW_TRIGGER,
  SET_WEBHOOK_SEARCH_KEYWORD,
  SET_WEBHOOK_VIEW_ACTIVE_PAGE,
  SET_WEBHOOK_VIEW_PAGE_SIZE,
} from './webhookActionTypes';
import { SELECTED_WEBHOOK_DETAIL_TAB } from '../../../../../utils/mixpanelEvents';
import MixpanelService from '../../../../../utils/mixpanelService';
import { DetailTabType } from '../../analyticsUiTypes';

/**
 * Select request in inspection view.
 * @param pageSize
 */
export const selectWebhookViewTriggered = (webhook: HttpRequest) => action(SELECT_WEBHOOK_VIEW_TRIGGER, webhook);

/**
 * Change active page in the request list.
 * @param tab
 */
export const changeWebhookViewActivePage = (activePage: number) => action(SET_WEBHOOK_VIEW_ACTIVE_PAGE, activePage);
/**
 * Update page size.
 * @param pageSize
 */
export const changeWebhookViewPageSize = (pageSize: number) => action(SET_WEBHOOK_VIEW_PAGE_SIZE, pageSize);
/**
 * Select request in inspection view.
 * @param pageSize
 */
export const setWebhookSearchKeyword = (searchKeyword: string) => action(SET_WEBHOOK_SEARCH_KEYWORD, searchKeyword);
/**
 * Select tab in webhook detail view
 * @param pageSize
 */
export const selectWebhookDetailTab = (tabName: DetailTabType) => {
  MixpanelService.track(SELECTED_WEBHOOK_DETAIL_TAB(tabName));
  return action(SELECT_WEBHOOK_DETAIL_TAB, tabName);
};
